import domReady from '@wordpress/dom-ready';

domReady(() => {
  const FWP = window.FWP;
  if (FWP) {
    document.addEventListener('facetwp-loaded', function () {
      const searchedKeyword = FWP.facets.global_search;

      const spanText = document.getElementById('fwp_search_word');
      if (spanText && searchedKeyword) {
        spanText.innerHTML = searchedKeyword;
      }
    });
  }
});
